import React, { useState } from "react";
import Swal from "sweetalert2";

function DocumentsForm({master}) {
    const [documents, setDocuments] = useState(null);
    const [error, setError] = useState('');
    const [downloadUrl, setDownloadUrl] = useState(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setDocuments(selectedFile);
        setError('');
        setDownloadUrl(null); // resetea por si vuelve a cargar otro archivo
    };

    const handleSave = () => {
        if (!documents) {
            setError('Campo requerido');
            return;
        }

        // Simulación de envío al backend
        console.log('Archivo seleccionado:', documents);

        // RL temporal para descarga
        const fileUrl = URL.createObjectURL(documents);
        setDownloadUrl(fileUrl);

        Swal.fire({
            title: "Carga de documentos realizada con éxito",
            icon: "success",
            customClass: {
                confirmButton: 'btn-ok',
                title: 'alert-title',
                popup: 'alert-bg'
            },
            confirmButtonText: "Cerrar",
        });
    }

    const handleDownload = () => {
        if (downloadUrl) {
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = documents.name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const handleConfirmDeparture =() => {
        alert('Confirmar SALIDA');
    }

    return(
        <>
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-6">
                        <label for="documents" class="amc-label">Documentos *</label>
                        {downloadUrl && (
                            <div className="row mb-3">
                                <div className="col">
                                    <span
                                        style={{ color: '#007bff', cursor: 'pointer' }}
                                        onClick={handleDownload}
                                    >
                                        Descargar documentos previamente cargados.
                                    </span>
                                </div>
                            </div>
                        )}
                        <input 
                            type="file"
                            class="form-control"
                            id="documents"
                            name="documents"
                            onChange={handleFileChange}
                        />
                        {error && <small className="text-danger mt-3">{error}</small>}
                        {downloadUrl && (
                            <div className="row mt-3">
                                <div className="col d-flex justify-content-center gap-3">
                                    <button className='btnn' onClick={handleConfirmDeparture} >Confirmar salida</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="row">
                    <div className="col mt-4 d-flex justify-content-end gap-3">
                        <button className='btnn' onClick={handleSave} >Guardar</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DocumentsForm;